export enum ConnectionStatus {
    NOT_CONNECTED = 'not_connected',
    CONNECTED = 'connected',
    PENDING = 'pending',
}
